import { render, staticRenderFns } from "./ProductImageEditor.vue?vue&type=template&id=678783ee&scoped=true"
import script from "./ProductImageEditor.vue?vue&type=script&lang=js"
export * from "./ProductImageEditor.vue?vue&type=script&lang=js"
import style0 from "./ProductImageEditor.vue?vue&type=style&index=0&id=678783ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678783ee",
  null
  
)

export default component.exports